module.exports={
  "Preview": "ForhÃ¥ndsvisning",
  "Copy": "Kopier"
}
